import { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { CloseButton, CloseButtonProps } from "../CloseButton";

import styles from "./styles.module.scss";

export type AlertProps = HtmlHTMLAttributes<HTMLDivElement> & {
  actions?: ReactNode | ReactNode[]
  actionsProps?: HtmlHTMLAttributes<HTMLDivElement>
  closeButtonProps?: CloseButtonProps
  floating?: boolean
  icon?: ReactNode,
  containerProps?: HtmlHTMLAttributes<HTMLDivElement>
  contentContainerProps?: HtmlHTMLAttributes<HTMLDivElement>
  iconContainerProps?: HtmlHTMLAttributes<HTMLDivElement>
  supportingText?: ReactNode | ReactNode[]
  supportingTextProps?: HtmlHTMLAttributes<HTMLDivElement>
}

export const Alert = memo(forwardRef<HTMLDivElement, AlertProps>((
  {
    actions,
    actionsProps,
    containerProps,
    contentContainerProps,
    closeButtonProps,
    floating,
    icon,
    iconContainerProps,
    children,
    className,
    supportingText,
    supportingTextProps,
    ...props
  },
  ref,
) => {
  return (
    <div
      {...props}
      className={classNames(
        className,
        styles.root,
        {
          [styles.floating]: floating,
          [styles.fullWidth]: !floating,
        },
      )}
      ref={ref}
    >
      <div
        {...containerProps}
        className={classNames(styles.container, containerProps?.className)}
      >
        {icon &&
          <div
            {...iconContainerProps}
            className={classNames(styles.iconContainer, iconContainerProps?.className)}
          >
            {icon}
          </div>
        }
        <div
          {...contentContainerProps}
          className={classNames(styles.contentContainer, contentContainerProps?.className)}
        >
          {children}
          {supportingText &&
            <div
              {...supportingTextProps}
              className={classNames(styles.supportingText, supportingTextProps?.className)}
            >
              {supportingText}
            </div>
          }
        </div>
        {actions &&
          <div
            {...actionsProps}
            className={classNames(styles.actions, actionsProps?.className)}
          >
            {actions}
          </div>
        }
        {closeButtonProps &&
          <CloseButton
            {...closeButtonProps}
            className={classNames(styles.closeBtn, closeButtonProps.className)}
          />
        }
      </div>
    </div>
  );
}));